module.exports = __webpack_public_path__ + "static/media/gb-sct.c4361672.svg";